export const modals = {
	confirmProductToggle: {
		deactivateProduct: "Desativar produto",
		activateProduct: "Ativar produto",
		confirmModalDescription: "Deseja {{action}} os produtos montáveis que ele compõe?",
	},
	confirmToggle: {
		deactivateProduct: "Desativar produto",
		activateProduct: "Ativar produto",
		toggleProducts: "Alternar apenas este produto",
	},
	deleteCategory: {
		title: "Excluir categoria",
		cancelButton: "Cancelar",
		moveAndDeleteButton: "Mover produtos e excluir categoria",
		deleteButton: "Excluir categoria",
		newCategoryLabel: "Nova categoria",
		selectNewCategoryPlaceholder: "Selecionar nova categoria",
		categoryDeletedSuccess: 'A categoria "{{categoryName}}" foi excluída com sucesso.',
		categoryDeletedAndProductsMovedSuccess:
			'A categoria "{{categoryName}}" foi excluída e seus produtos foram movidos para "{{newCategoryName}}".',
		categoryWithProductsDescription:
			"Esta categoria possui <strong>{{productCount}} produto</strong> vinculado. Antes de excluir a " +
			"categoria você precisa mudar os produtos para outra categoria",
		categoryWithProductsDescription_plural:
			"Esta categoria possui <strong>{{productCount}} produtos</strong> vinculados. Antes de excluir a " +
			"categoria você precisa mudar os produtos para outra categoria",
		confirmDeleteCategoryDescription:
			"Tem certeza que deseja excluir esta categoria? <strong>Esta ação não pode ser desfeita.</strong>",
	},
	massEdit: {
		title: "Edição em massa de produtos",
		completeButton: "Concluir",
		cancelButton: "Cancelar",
		comingSoon: "Em breve: fluxo de edição em massa",
		selectedCount: "{{count}} {{unit}} selecionado",
		selectedCount_plural: "{{count}} {{unit}} selecionados",
		selectedProduct: "Produto selecionado",
		selectedProducts: "Produtos selecionados",
		instruction: 'Clique em "Concluir" para prosseguir com a exclusão da categoria.',
		fields: {
			category: {
				label: "Categoria",
				placeholder: "Escolha a nova categoria",
			},
			type: {
				label: "Tipo",
				placeholder: "Escolha um novo tipo",
			},
			fiscalGroup: {
				label: "Grupo fiscal",
				placeholder: "Escolha um novo grupo fiscal",
			},
			fiscalProfile: {
				label: "Perfil fiscal",
				placeholder: "Escolha um novo perfil fiscal",
			},
		},
	},
	massActions: {
		itemSelected: "Produtos selecionado",
		itemsSelected: "Produtos selecionados",
		editSelected: "Editar Itens selecionados",
		activateAll: "Ativar todos",
		deactivateAll: "Desativar todos",
	},
	duplicateProductDrawer: {
		title: "Duplicar produto montável",
		stepTitles: {
			duplicateProduct: "Duplicar Produto",
			selectProducts: "Selecionar Produtos",
		},
		duplicationChoice: {
			createNewProduct: {
				title: "Criar novo produto montável",
				description: "Duplique o montável usar em um novo produto",
			},
			batchDuplicate: {
				title: "Importar duplicada em lote",
				description: "Importe a etapa de montável para produtos já criados",
			},
		},
		actions: {
			cancel: "Cancelar",
			back: "Voltar",
			duplicate: "Duplicar montável",
			addProducts: "Adicionar produtos",
			comingSoon: "Esta funcionalidade será implementada em breve",
			noMountableData: "Nenhum dado montável para duplicar",
		},
		productSelection: {
			label: "Selecione os produtos que receberão o montável:",
			placeholder: "Selecione os produtos...",
			selectedProducts: "Produtos selecionados",
			emptyState: {
				title: "Nenhum produto selecionado",
				description: "Adicione os produtos que você deseja duplicar o montável",
			},
			successMessage:
				'Configurações de "{{productName}}" foram aplicadas a {{count}} produto com sucesso.',
			successMessage_plural:
				'Configurações de "{{productName}}" foram aplicadas a {{count}} produtos com sucesso.',
		},
	},
	deleteProduct: {
		cancel: "Cancelar",
		delete: "Apagar",
		confirmDeleteMessage:
			'Tem certeza que deseja excluir o produto <strong>"{{productName}}"</strong>?',
	},
	deleteProducts: {
		title: "Excluir produtos selecionados {{count}}",
		cancelButton: "Cancelar",
		deleteButton: "Excluir produto",
		deleteButton_plural: "Excluir {{count}} produtos",
		description:
			"Os {{count}} produtos selecionados serão apagados deste local e essa ação não pode ser " +
			"desfeita (você poderá visualizar eles no nível org).",
		confirmQuestion: "Tem certeza de que deseja continuar?",
		deleteSuccess: "Produto excluído com sucesso",
		deleteSuccess_plural: "{{count}} produtos excluídos com sucesso",
	},
	exitMassEditMode: {
		title: "Deseja sair do modo de edição em massa?",
		description:
			"Você tem produtos selecionados. Ao navegar para outra categoria, a seleção será perdida.",
		confirmButton: "Sim, sair",
		cancelButton: "Cancelar",
	},
};
